/**
 * Erros de plano vindos do backend — detecção CANÔNICA.
 *
 * Invariante 4 (valor canônico): existe UMA função por formato. Este módulo é a
 * casa de `isFeatureNotIncluded`; `pages/MessageCenter/messageCenterHelpers.js`
 * apenas reexporta para não quebrar os imports existentes.
 *
 * Códigos emitidos pelo backend (`planMiddleware` / `requireScheduling`):
 *  • FEATURE_NOT_INCLUDED — o plano não inclui a capacidade (CRM, agendamento).
 *  • LIMIT_REACHED        — o plano inclui, mas o limite de volume estourou.
 * São eixos diferentes e NUNCA devem ser tratados com a mesma mensagem: um pede
 * upgrade de tier, o outro pede upgrade de volume (ou faxina).
 */

/** Código do 403 de capacidade ausente no plano. */
export const FEATURE_NOT_INCLUDED = "FEATURE_NOT_INCLUDED";

/**
 * `true` quando o erro Axios é o 403 de capacidade ausente no plano.
 *
 * Exige status 403 E o code — um 401 com o mesmo corpo é sessão expirada, não
 * plano insuficiente, e cai no interceptor de auth.
 *
 * @param {unknown} err erro capturado (esperado: AxiosError)
 * @returns {boolean}
 */
export function isFeatureNotIncluded(err) {
  return (
    err?.response?.status === 403 &&
    err?.response?.data?.code === FEATURE_NOT_INCLUDED
  );
}

/**
 * Mensagem humana para o 403 de agendamento (ADR-0026). Nunca vaza o texto cru
 * do backend — quem lê é o dono do negócio, não um dev.
 */
export const SCHEDULING_NOT_INCLUDED_MESSAGE =
  "Agendamento não faz parte do seu plano. Faça upgrade para liberar a agenda.";

/**
 * Código do 403 de cobrança: trial vencido, assinatura em atraso ou cancelada.
 * Emitido por `planMiddleware` (backend) quando o tenant não pode mais operar
 * por motivo de PAGAMENTO — eixo distinto de `FEATURE_NOT_INCLUDED` (tier) e de
 * `LIMIT_REACHED` (volume). Aqui o plano até incluiria a capacidade; o que
 * falta é a assinatura estar em dia.
 */
export const PAYMENT_REQUIRED = "PAYMENT_REQUIRED";

/**
 * `true` quando o erro Axios é o 403 de cobrança pendente.
 *
 * 🔴 Este erro NÃO desloga. É o inverso exato do 401: o dono precisa continuar
 * dentro do app justamente para conseguir pagar. Quem o trata (interceptor de
 * `services/api.js`) só registra e deixa o erro seguir para o `.catch` da tela.
 *
 * Exige status 403 E o code, pela mesma razão de `isFeatureNotIncluded`.
 *
 * @param {unknown} err erro capturado (esperado: AxiosError)
 * @returns {boolean}
 */
export function isPaymentRequired(err) {
  return (
    err?.response?.status === 403 &&
    err?.response?.data?.code === PAYMENT_REQUIRED
  );
}
